import { Chip, emptyFragment } from '@execonline-inc/execonline-ui';
import { AlreadyTranslated } from '@execonline-inc/translations';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { Experience } from '../../../Common/Experience/Types';
import {
  ExperienceDetailsSection,
  ExperienceDetailsSectionHeader,
} from '../ExperienceDetailsSection';

interface Props {
  experience: Experience;
}

function ExperienceYouWillGain({ experience }: Props) {
  return fromEmpty(experience.primaryCompetencies)
    .map((competencies) => (
      <ExperienceDetailsSection data-intercom-target="experience-competencies-section">
        <ExperienceDetailsSectionHeader title="Competencies you will gain" />
        <div className="flex flex-wrap gap-2 lg:gap-4">
          {competencies.map((competency) => (
            <Chip
              key={competency.payload.id}
              className="px-3 py-1.5"
              size="sm"
              variant="outlined"
              radius="md"
              color="gray"
              data-intercom-target="discovery-portal-competency-chip"
              tabIndex={0}
            >
              <AlreadyTranslated content={competency.payload.name} />
            </Chip>
          ))}
        </div>
      </ExperienceDetailsSection>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ExperienceYouWillGain);
